/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HomeownershipTermsDeclineRequest
 */
export interface HomeownershipTermsDeclineRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsDeclineRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsDeclineRequest
     */
    termsId: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsDeclineRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsDeclineRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsDeclineRequest
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipTermsDeclineRequest
     */
    consentAccepted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipTermsDeclineRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the HomeownershipTermsDeclineRequest interface.
 */
export function instanceOfHomeownershipTermsDeclineRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "termsId" in value;

    return isInstance;
}

export function HomeownershipTermsDeclineRequestFromJSON(json: any): HomeownershipTermsDeclineRequest {
    return HomeownershipTermsDeclineRequestFromJSONTyped(json, false);
}

export function HomeownershipTermsDeclineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipTermsDeclineRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'termsId': json['terms_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'consentAccepted': !exists(json, 'consent_accepted') ? undefined : json['consent_accepted'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function HomeownershipTermsDeclineRequestToJSON(value?: HomeownershipTermsDeclineRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'terms_id': value.termsId,
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'consent_accepted': value.consentAccepted,
        'reason': value.reason,
    };
}

